export default __webpack_public_path__ + "static/media/RocketBlue.a6f13822.svg";